<template>
  <img :src="pathImage" alt="Caminhão" width="70px" height="70px" />
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import pathImage from '../../../assets/mapa-industrial-dinamico/caminhao.gif'

@Component({
  name: 'TruckIcon'
})
class TruckIcon extends Vue {
 pathImage = pathImage
}
export default TruckIcon
</script>
<style>

</style>
